import React, { useEffect, useState } from "react"; import { useHistory } from "react-router-dom";
import NavigationServicesHeader from "../../../Header/NavigationServicesHeader"; import * as OFMSUI from "react-bootstrap";
import { ErrorMessage, Field, Form, FormikProvider, useFormik } from "formik";
import { AiOutlineSearch } from "react-icons/ai"; import { MdOutlinePictureAsPdf } from "react-icons/md";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import { store } from "../../../App";
import HousingService from "../../../Services/HousingService";
import * as Yup from "yup"; import jsPDF from "jspdf"; import { FaSearch } from "react-icons/fa"; import moment from "moment";
import { GetDetails, ModuleHeader } from "../../utils/commonFunctions";

const Financeadditionalexpenditurereport = () => {
    const history = useHistory();
    const [data, setData] = useState([]); const [tableEn, setTableEn] = useState(false);
    const [search, setSearch] = useState(""); const [distList, setDistList] = useState([]);
    const [error, setError] = useState(null); const [schemeList, setSchemeList] = useState([]);
    const [isFocused, setIsFocused] = useState(false);
    const handleFocus = () => setIsFocused(true);
    const handleBlur = () => setIsFocused(false);


    const formik = useFormik({
        initialValues: {
            report_type: "",
            district: "",
            FromDate: "",
            ToDate: "",
            scheme: "",
            Caste: "0",
        },
        validationSchema: Yup.object().shape({
            report_type: Yup.string().required("Report type is required"),
            // district: Yup.string().when("report_type", {
            //     is: "District",
            //     then: Yup.string().required("District is required"),
            //     otherwise: Yup.string(),
            //   }),
            district: Yup.string().when("report_type", {
                is: "phase",
                then: Yup.string()
                    .required("District is required")
                    .notOneOf(["0", ""], "District is required"),
                otherwise: Yup.string().notRequired(),
            }),
            //   scheme: Yup.string().when("report_type", {
            //     is: "phase",
            //     then: Yup.string().required("Phase is required"),
            //     otherwise: Yup.string(),
            //   }),
            FromDate: Yup.string().required("FromDate is required"),
            ToDate: Yup.string().required("ToDate is required"),
        }),
        onSubmit: (values) => {
            let params = {
                reportType: values.report_type,
                distCode: values.district,
                fromDate: moment(values.FromDate, "YYYY-MM-DD").format("DD/MM/YYYY"),
                toDate: moment(values.ToDate, "YYYY-MM-DD").format("DD/MM/YYYY"),
                caste: values.Caste,
                phase: values.scheme,
            }
            store.dispatch({ type: "SHOW_SPINNER" })
            HousingService.financeaddtionalexp(params).then((res) => {
                setData(res.data); setTableEn(true);
            }).finally(() => { store.dispatch({ type: "HIDE_SPINNER" }) })
        }
    })

    useEffect(() => {
        formik.resetForm()
        setTableEn(false)
        fetch('/districts.txt').then(response => response.text()).then(text => {
            const data = JSON.parse(text);
            let options = data[0].Districts?.map((item, i) => (<option key={i} value={item.dist_code}>{item.dist_name}</option>))
            setDistList(options)
        });
        fetch('/schems_dropdown.txt')
            .then(response => {
                if (!response.ok) { throw new Error('Network Issues'); }
                return response.json();
            })
            .then(jsonData => {
                setSchemeList(jsonData || []);
            })
            .catch(error => {
                setError(error);
            },);
    }, []);
    if (error) { return <div>Error: {error.message}</div>; }



    const filteredData = search.length > 0 ? data?.filter((item) => {
        return (
            item && Object.keys(item).some((key) => {
                const value = item[key];
                return (
                    value !== null && value.toString().toLowerCase().includes(search.toLowerCase()));
            }));
    }) :
        data;


    const handleGoBack = () => { history.goBack(); }

    function generate(table) {
        const pageWidth = 250; const pageHeight = 297;
        const doc = new jsPDF({ orientation: "landscape", unit: "mm", format: [pageWidth, pageHeight], });
        const headingText = "Financeadditionalexpenditurereport"; const fontSize = 10;
        const textWidth = (doc.getStringUnitWidth(headingText) * fontSize) / doc.internal.scaleFactor;
        const xCoordinate = (pageWidth - textWidth) / 2;
        doc.setFontSize(fontSize); doc.text(headingText, xCoordinate, 10);
        doc.autoTable({
            html: `#${table}`, theme: "grid", tableWidth: "auto",
            columnStyles: { 8: { cellWidth: "wrap" }, }, startY: 20, margin: {
                top: 5,
                right: 5, bottom: 5, left: 5
            }, styles: { fontSize: 8, },
        });
        doc.save("Financeadditionalexpenditurereport.pdf");
    }


    return (
        <>
            <NavigationServicesHeader />
            <ModuleHeader title="Finance Year Wise Progress and Expenditure Report" />

            <OFMSUI.Container className="outer-page-content-container" fluid style={{ width: "90%" }}>
                <OFMSUI.Row>
                    <OFMSUI.Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3}>
                        <ol className="breadcrumb"> <li className="breadcrumb-item">
                            <a href="Dashboardheader">Dashboard</a> </li>
                            <li className="breadcrumb-item active" aria-current="page"> Report </li> </ol>
                    </OFMSUI.Col>
                </OFMSUI.Row>

                <FormikProvider value={formik}>
                    <Form onSubmit={formik.handleSubmit}>
                        <OFMSUI.Row className="border p-3 m-1 mb-3 align-items-center">
                            <OFMSUI.Col xs={12} sm={6} md={4} lg={2} xl={2} xxl={2} className="mb-3">
                                <label>
                                    <b> Report Type<span className="mandatory" style={{ color: "red" }}>   {" "} * </span> </b>
                                </label>
                                <Field
                                    component="select"
                                    name="report_type"
                                    className={formik.touched.report_type && formik.errors.report_type ? "form-control is-invalid" : "form-control"}
                                    onChange={(e) => {

                                        formik.handleChange(e);
                                        formik.setValues({
                                            ...formik.values,
                                            report_type: e.target.value,
                                            district: "0",
                                            Caste: "0",
                                            FromDate: "",
                                            ToDate: "",
                                            scheme: "0",
                                        });
                                        setTableEn(false);
                                    }}
                                >
                                    <option value="">Select</option>
                                    <option value="District">District Wise</option>
                                    <option value="phase">Phase Wise</option>
                                </Field>
                            </OFMSUI.Col>

                            {(formik.values.report_type === "District" || formik.values.report_type === "phase") && (
                                <OFMSUI.Col xs={12} sm={6} md={4} lg={2} xl={2} xxl={2} className="mb-3">
                                    <label><b>District</b></label>
                                    <Field
                                        component="select"
                                        name="district"
                                        className={formik.touched.district && formik.errors.district ? "form-control is-invalid" : "form-control"}
                                        onChange={(e) => {
                                            formik.handleChange(e);
                                        }}
                                    >
                                        {formik.values.report_type === "District" ? (
                                            <>
                                                <option value="0">All</option>
                                                {distList}
                                            </>
                                        ) : formik.values.report_type === "phase" ? (
                                            <>
                                                <option value="">Select</option>
                                                {distList}
                                            </>
                                        ) : null}
                                    </Field>
                                    <ErrorMessage name="district" className="text-error" component="div" />
                                </OFMSUI.Col>
                            )}

                            {formik.values.report_type === "phase" && (
                                <OFMSUI.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className="mb-3">
                                    <label><b>Phase</b></label>
                                    <Field
                                        component="select"
                                        name="scheme"
                                        className={formik.touched.scheme && formik.errors.scheme ? "form-control is-invalid" : "form-control"}
                                    >
                                        <option value="0">All</option>
                                        {schemeList?.map((scheme) => (
                                            <option key={scheme.scheme_id} value={scheme.scheme_id}>
                                                {scheme.scheme_name}
                                            </option>
                                        ))}
                                    </Field>
                                </OFMSUI.Col>
                            )}
                            <OFMSUI.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2} className="mb-3">
                                <label> <b>Caste</b> </label>
                                <Field component="select" name="Caste" className={
                                    formik.touched.Caste && formik.errors.Caste ? "form-control is-invalid" : "form-control"}
                                    onChange={(e) => { formik.handleChange(e); }} >
                                    <option value="0">All</option>
                                    <option value="1">SC</option>
                                    <option value="2">ST</option> <option value="3">BC</option> <option value="4">OC</option> <option value="5">OTHERS</option>
                                </Field>
                            </OFMSUI.Col>

                            <OFMSUI.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2} className="mb-3">
                                <label> <b>From Date</b> </label>
                                <span className="mandatory" style={{ color: "red" }}> * </span>
                                <Field type="date" name="FromDate" className={
                                    formik.touched.FromDate && formik.errors.FromDate ? "form-control is-invalid" : "form-control"} max={new Date().toISOString().split("T")[0]}
                                    onChange={(e) => { formik.handleChange(e); }} >
                                </Field>
                            </OFMSUI.Col>

                            <OFMSUI.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2} className="mb-3">
                                <label> <b>To Date</b> </label>
                                <span className="mandatory" style={{ color: "red" }}> * </span>
                                <Field type="date" name="ToDate" className={
                                    formik.touched.ToDate && formik.errors.ToDate ? "form-control is-invalid" : "form-control"} max={new Date().toISOString().split("T")[0]}
                                    onChange={(e) => { formik.handleChange(e); }} >
                                </Field>
                            </OFMSUI.Col>
                        <GetDetails/>
                        </OFMSUI.Row>
                        {tableEn && <>
                            <OFMSUI.Row className="mt-3 mb-3">
                                <OFMSUI.Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} className=" mb-3" >
                                    {/* <div className="input-group">
                                        <div className="input-group-prepend"> <div className="input-group-text group_txt11" id="btnGroupAddon" > 
                                            <AiOutlineSearch /> </div> </div>
                                        <input type="text" id="" placeholder="Search" style={{ width: "25%" }} 
                                        className="form-control input-lg" value={search} onChange={(e) => { setSearch(e.target.value) }} ></input>
                                    </div> */}
                                    <div
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            position: "relative",
                                            width: "400px",
                                            height: "40px",
                                            background: isFocused
                                                ? "linear-gradient(90deg,rgb(224, 253, 117), #7873f5)"
                                                : "linear-gradient(90deg, #f5f7fa, #b8c6db)",
                                            borderRadius: "20px",
                                            padding: "5px 10px",
                                            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                                            transition: "background 0.4s ease",
                                        }}
                                    >

                                        <AiOutlineSearch
                                            icon={FaSearch}
                                            style={{
                                                position: "absolute",
                                                left: isFocused ? "90%" : "5%",
                                                transition: "left 1s ease, color 0.4s ease",
                                                fontSize: "20px",
                                                color: isFocused ? "#fff" : "#888",
                                            }}
                                        />
                                        <input
                                            type="text"
                                            placeholder="Search..."
                                            value={search}
                                            onChange={(e) => setSearch(e.target.value)}
                                            onFocus={handleFocus}
                                            onBlur={handleBlur}
                                            style={{
                                                width: "100%", height: "100%", border: "none", outline: "none", paddingLeft: "35px", borderRadius: "20px", background: "transparent", color: "#444",
                                                fontSize: "16px",
                                                fontFamily: "Arial, sans-serif",
                                            }}
                                        />
                                    </div>
                                </OFMSUI.Col>

                                <OFMSUI.Col xs={12} sm={12} md={9} lg={9} xl={9} xxl={9} className=" mb-2 float-end" >
                                    <button type="button" className="btn btn-danger btn-sm" onClick={() => generate("my-table")}
                                        style={{ float: "right", marginLeft: "3px" }} > PDF <MdOutlinePictureAsPdf /> </button>
                                    <div style={{ float: "right", marginLeft: "3px" }}> <ReactHTMLTableToExcel id="test-table-xls-button"
                                        className="btn btn-success btn-sm" table="my-table"
                                        filename="Financeadditionalexpenditurereport" sheet="tablexls" buttonText="Excel" style={{
                                            backgroundColor: '#603913',
                                            borderColor: '#603913', color: '#ffffff',
                                            padding: '5px 10px', borderRadius: '4px', cursor: 'pointer', display: 'inline-flex', alignItems: 'center',
                                            justifyContent: 'center'
                                        }} /> </div>
                                </OFMSUI.Col>
                            </OFMSUI.Row>
                            <div style={{ overflow: "auto", height: "500px" }}>
                                <OFMSUI.Table hover id="my-table" style={{ width: "100%" }}>
                                    <thead className="fw-bold" style={{ top: "0px", position: "sticky" }}>
                                        <tr >
                                            <th rowSpan={2}>S.No.</th>
                                            {formik.values.report_type === "District" && <th rowSpan={2}>District</th>}
                                            {formik.values.report_type === "phase" && <th rowSpan={2}>Phase</th>}
                                            {/* <th>Caste</th> */}
                                            <th rowSpan={2} style={{ textAlign: "center" }}>Unit Cost</th>


                                            <th colSpan={6} style={{ textAlign: "center" }}>Physical Progress</th>

                                            <th colSpan={2} style={{ textAlign: "center" }}>Brick</th>
                                            <th colSpan={2} style={{ textAlign: "center" }}>SCST Additional Charges</th>

                                            <th colSpan={2} style={{ textAlign: "center" }}>Cash</th>


                                            <th colSpan={2} style={{ textAlign: "center" }}>Cement</th>

                                            <th colSpan={2} style={{ textAlign: "center" }}>Sand </th>

                                            <th colSpan={2} style={{ textAlign: "center" }}>Steel </th>

                                            <th colSpan={2} style={{ textAlign: "center" }}>Other Materails</th>

                                            <th rowSpan={2} style={{ textAlign: "center" }}>Admin Charges</th>

                                            <th rowSpan={2} style={{ textAlign: "center" }}>Total</th>
                                        </tr>
                                        <tr>
                                            <th style={{ textAlign: "center" }}>NS</th>
                                            <th style={{ textAlign: "center" }}>BBL</th>
                                            <th style={{ textAlign: "center" }}>BL</th>
                                            <th style={{ textAlign: "center" }}>RL</th>
                                            <th style={{ textAlign: "center" }}>RC</th>
                                            <th style={{ textAlign: "center" }}>Completion</th>

                                            <th style={{ textAlign: "center" }}>No.of Beneficiaries</th>
                                            <th style={{ textAlign: "center" }}>Payment</th>
                                            <th style={{ textAlign: "center" }}>No.of Beneficiaries</th>
                                            <th style={{ textAlign: "center" }}>Payment</th>
                                            <th style={{ textAlign: "center" }}>No.of Beneficiaries</th>
                                            <th style={{ textAlign: "center" }}>Payment</th>
                                            <th style={{ textAlign: "center" }}>Quantity in Bags</th>
                                            <th style={{ textAlign: "center" }}>Payment</th>
                                            <th style={{ textAlign: "center" }}>Quantity</th>
                                            <th style={{ textAlign: "center" }}>Payment</th>
                                            <th style={{ textAlign: "center" }}>Quantity in Kgs</th>
                                            <th style={{ textAlign: "center" }}>Payment</th>
                                            <th style={{ textAlign: "center" }}>Quantity</th>
                                            <th style={{ textAlign: "center" }}>Payment</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {filteredData?.length === 0 || filteredData === undefined ? (
                                            <tr>
                                                <td colSpan={24} style={{ fontSize: "15px", textAlign: "center" }}>
                                                    No details found
                                                </td>
                                            </tr>
                                        ) : (
                                            filteredData.map((detail, i) => (
                                                <tr key={i}>
                                                    <td>{i + 1}</td>
                                                    {formik.values.report_type === "District" && <td>{detail.dist_name}</td>}
                                                    {formik.values.report_type === "phase" && <td>{detail.phase_name}</td>}
                                                    {/* <td>{detail.caste_name}</td> */}
                                                    <td style={{ textAlign: "right" }}>{detail.unitcost || 0}</td>

                                                    <td style={{ textAlign: "right" }}>{detail.physical_ns || 0}</td>
                                                    <td style={{ textAlign: "right" }}>{detail.physical_bbl || 0}</td>
                                                    <td style={{ textAlign: "right" }}>{detail.physical_bl || 0}</td>
                                                    <td style={{ textAlign: "right" }}>{detail.physical_rl || 0}</td>
                                                    <td style={{ textAlign: "right" }}>{detail.physical_rc || 0}</td>
                                                    <td style={{ textAlign: "right" }}>{detail.physical_comp || 0}</td>

                                                    <td style={{ textAlign: "right" }}>{detail.brick_no || 0}</td>
                                                    <td style={{ textAlign: "right" }}>{detail.brick_pay || 0}</td>
                                                    <td style={{ textAlign: "right" }}>{detail.scst_no || 0}</td>
                                                    <td style={{ textAlign: "right" }}>{detail.scst_pay || 0}</td>
                                                    <td style={{ textAlign: "right" }}>{detail.cash_no || 0}</td>
                                                    <td style={{ textAlign: "right" }}>{detail.cash_payment || 0}</td>



                                                    <td style={{ textAlign: "right" }}>{detail.cement_qty || 0}</td>
                                                    <td style={{ textAlign: "right" }}>{detail.cement_amt || 0}</td>


                                                    <td style={{ textAlign: "right" }}>{detail.sand_no || 0}</td>
                                                    <td style={{ textAlign: "right" }}>{detail.sand_amt || 0}</td>

                                                    <td style={{ textAlign: "right" }}>{detail.steel_no || 0}</td>
                                                    <td style={{ textAlign: "right" }}>{detail.steel_amt || 0}</td>

                                                    <td style={{ textAlign: "right" }}>{detail.other_no || 0}</td>
                                                    <td style={{ textAlign: "right" }}>{detail.other_amt || 0}</td>
                                                    <td style={{ textAlign: "right" }}>{detail.admin_charges || 0}</td>

                                                    <td style={{ textAlign: "right" }}>{(detail.brick_pay + detail.scst_pay + detail.cement_amt + detail.sand_amt + detail.steel_amt + detail.other_amt + detail.cash_payment + detail.admin_charges || 0)}</td>
                                                </tr>
                                            ))
                                        )}
                                    </tbody>

                                    {filteredData?.length > 0 && (
                                        <tfoot style={{ position: "sticky", bottom: "0px" }}>
                                            <tr>
                                                <td colSpan={2} style={{ textAlign: "center" }}>Total</td>
                                                <td style={{ textAlign: "right" }}>{filteredData.reduce((a, v) => a + (parseInt(v.unitcost) || 0), 0)}</td>
                                                <td style={{ textAlign: "right" }}>{filteredData.reduce((a, v) => a + (parseInt(v.physical_ns) || 0), 0)}</td>
                                                <td style={{ textAlign: "right" }}>{filteredData.reduce((a, v) => a + (parseInt(v.physical_bbl) || 0), 0)}</td>
                                                <td style={{ textAlign: "right" }}>{filteredData.reduce((a, v) => a + (parseInt(v.physical_bl) || 0), 0)}</td>
                                                <td style={{ textAlign: "right" }}>{filteredData.reduce((a, v) => a + (parseInt(v.physical_rl) || 0), 0)}</td>
                                                <td style={{ textAlign: "right" }}>{filteredData.reduce((a, v) => a + (parseInt(v.physical_rc) || 0), 0)}</td>
                                                <td style={{ textAlign: "right" }}>{filteredData.reduce((a, v) => a + (parseInt(v.physical_comp) || 0), 0)}</td>

                                                <td style={{ textAlign: "right" }}>{filteredData.reduce((a, v) => a + (parseInt(v.brick_no) || 0), 0)}</td>
                                                <td style={{ textAlign: "right" }}>{filteredData.reduce((a, v) => a + (parseInt(v.brick_pay) || 0), 0)}</td>
                                                <td style={{ textAlign: "right" }}>{filteredData.reduce((a, v) => a + (parseInt(v.cash_no) || 0), 0)}</td>
                                                <td style={{ textAlign: "right" }}>{filteredData.reduce((a, v) => a + (parseInt(v.cash_payment) || 0), 0)}</td>
                                                <td style={{ textAlign: "right" }}>{filteredData.reduce((a, v) => a + (parseInt(v.scst_no) || 0), 0)}</td>
                                                <td style={{ textAlign: "right" }}>{filteredData.reduce((a, v) => a + (parseInt(v.scst_pay) || 0), 0)}</td>

                                                <td style={{ textAlign: "right" }}>{filteredData.reduce((a, v) => a + (parseInt(v.cement_qty) || 0), 0)}</td>
                                                <td style={{ textAlign: "right" }}>{filteredData.reduce((a, v) => a + (parseInt(v.cement_amt) || 0), 0)}</td>


                                                <td style={{ textAlign: "right" }}>{filteredData.reduce((a, v) => a + (parseInt(v.sand_no) || 0), 0)}</td>
                                                <td style={{ textAlign: "right" }}>{filteredData.reduce((a, v) => a + (parseInt(v.sand_amt) || 0), 0)}</td>

                                                <td style={{ textAlign: "right" }}>{filteredData.reduce((a, v) => a + (parseInt(v.steel_no) || 0), 0)}</td>
                                                <td style={{ textAlign: "right" }}>{filteredData.reduce((a, v) => a + (parseInt(v.steel_amt) || 0), 0)}</td>
                                                <td style={{ textAlign: "right" }}>{filteredData.reduce((a, v) => a + (parseInt(v.other_no) || 0), 0)}</td>
                                                <td style={{ textAlign: "right" }}>{filteredData.reduce((a, v) => a + (parseInt(v.other_amt) || 0), 0)}</td>
                                                <td style={{ textAlign: "right" }}>{filteredData.reduce((a, v) => a + (parseInt(v.admin_charges) || 0), 0)}</td>

                                                <td style={{ textAlign: "right" }}>{filteredData.reduce((a, v) => a + (parseInt((v.brick_pay + v.other_amt + v.scst_pay + v.cement_amt + v.sand_amt + v.steel_amt + v.cash_payment + v.admin_charges)) || 0), 0)}</td>

                                            </tr>
                                        </tfoot>
                                    )}
                                </OFMSUI.Table>
                            </div>       </>} </Form>
                </FormikProvider> </OFMSUI.Container> </>)
}
export default Financeadditionalexpenditurereport